/** Preview is a browser navigation, never a server-side fetch or proxy. */
export function trafficPreviewUrl(value: string | null, managementOrigin: string): string | null {
  if (!value) return null
  try {
    const url = new URL(value)
    const host = url.hostname.toLowerCase().replace(/\.$/, '')
    if (
      url.protocol !== 'https:' ||
      url.username ||
      url.password ||
      url.port ||
      url.origin === managementOrigin ||
      !host.includes('.') ||
      /(^|\.)(localhost|local|internal|lan|test|invalid)$/.test(host) ||
      host.includes(':') ||
      /^[\d.]+$/.test(host)
    )
      return null
    url.search = ''
    url.hash = ''
    return url.href
  } catch {
    return null
  }
}
